import { render, staticRenderFns } from "./DesignComponentsProductData.vue?vue&type=template&id=cdddd4a0&scoped=true"
import script from "./DesignComponentsProductData.vue?vue&type=script&lang=js"
export * from "./DesignComponentsProductData.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsProductData.vue?vue&type=style&index=0&id=cdddd4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdddd4a0",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsProductData.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports